import { DesktopDatePicker } from "@mui/x-date-pickers";
import { IncidentDatePickerProps } from "../types";
import { incidentTableStyles } from "./styles";

const getDatePickerValue = (timestamp: number | null): Date | null => {
  return timestamp ? new Date(timestamp) : null;
};

export function IncidentDatePicker({
  label,
  value,
  filterKey,
  onChange,
}: IncidentDatePickerProps) {
  return (
    <DesktopDatePicker<Date>
      label={label}
      value={getDatePickerValue(value)}
      onChange={(nextValue) => onChange(filterKey, nextValue)}
      format="dd/MM/yyyy"
      minDate={new Date("2018-01-01")}
      slotProps={{
        textField: {
          size: "small",
          variant: "outlined",
          sx: incidentTableStyles.datePickerTextFieldSx,
        },
        day: {
          sx: incidentTableStyles.datePickerDaySx,
        },
      }}
    />
  );
}
